import Detenteur from "../models/Detenteur";
import localforage from "localforage";
import { enregistrerOtags } from "./Otags";

class Asynchro
{

    static workerData(data)
    {
        if (typeof data === "object") {
            if (data.action === "asynchro") {

                if(data.type === "detenteurs") {
                    localforage.getItem('syncInProgress').then(function(syncing) {
                        if (syncing === 'true') return;
                        Detenteur.stockDetenteursOnLocal(data.data).then(function () {
                            localStorage.setItem('asyncDetenteurs', false);
                            const event = new Event('localStorageAsyncDetenteurs');
                            window.dispatchEvent(event);
                            console.log('detenteurs stockés')
                        })
                    });
                }


                if(data.type === "otags") {
                    enregistrerOtags(data.data).catch(function (err) {
                        console.error('Échec de l\'enregistrement des otags', err);
                    });
                }

            }
        }
    }

}
export default Asynchro;



// WEBPACK FOOTER //
// ./src/js/core/Asynchro.js